import React, { useEffect, useRef, useState } from 'react'
import { MultiSelect } from "react-multi-select-component";
import './finance.scss';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import { toast } from 'react-toastify';
import Spinner from 'react-bootstrap/Spinner';
// react-select import removed after switching to MultiSelect for products
const base_url = "https://mis-api.happimobiles.com/";
// const base_url='http://localhost:8030/';

const FinanceReports = () => {
  const [selected, setSelected] = useState([]);
  const defaultStartDate = new Date();
  const defaultEndDate = new Date();
  const [startDate, setStartDate] = useState(defaultStartDate);
  const [endDate, setEndDate] = useState(defaultEndDate);
  const [productList, setProductList] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState([]);
  const [itemName, setItemName] = useState("");
  const [itemsList, setItemsList] = useState([]);
  const [financeReportFormData, setFinanceReportFormData] = useState({ submitBtnLoader: false });
  const [selectedItem, setSelectedItem] = useState([]);
  const [overlapErrorIdxs, setOverlapErrorIdxs] = useState([]);
  const rowRefs = useRef({});
  const [showResyncModal, setShowResyncModal] = useState(false);
  const currentDate = new Date();
  const [resyncData, setResyncData] = useState({
  month: '',
  year: currentDate.getFullYear()
  });

  useEffect(() => {
    document.title = 'Finance Reports'
    getProductsData()
  }, []);

  const onChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const getProductsData = async () => {
    try {
      let { data } = await axios(`${base_url}api/finance/productNames`);
      setProductList(data?.productNames)
    }
    catch (e) {
      toast.error("Network error try again later")
    }
  }

  const onProductSelection = async (val) => {
    setBrandList({ loader: true })
    if (!val.length) return setSelectedProduct(val)
    setSelectedProduct(val)
    let { data } = await axios(`${base_url}api/finance/brandNames?product_name=${val.map(item => item.label).toString()}`)
    setBrandList(data?.rows)
  }

  

  const onBrandSelection = async (val) => {
    setSelectedBrand(val)
    setItemName("")
    
    if (!val || val.length === 0) {
      setItemsList([])
      return
    }
    
    // Handle multiple brand selections
    const brandNames = val.map(brand => brand.value).join(',')
    const productNames = Array.isArray(selectedProduct) && selectedProduct.length > 0
      ? selectedProduct.map(p => p.value).join(',')
      : (selectedProduct?.value || '')
    let { data } = await axios(`${base_url}api/finance/itemMetaNames?brand_name=${brandNames}&product_name=${productNames}`)
    const rows = data?.rows || []
    const normalized = rows.map(item => ({
      ...item,
      from_date: formatDate(item.from_date),
      to_date: formatDate(item.to_date),
      mop: item.mop ?? item.dp_mop // prefill editable value with current dp_mop
    }))
    setItemsList(normalized)
  }

  const getProductOptions = () => productList.length > 0 ? productList?.map(item => ({ label: item, value: item })) : []
  const getBrandOptions = () => brandList.length > 0 ? brandList?.map(item => ({ label: item.brand_name, value: item.brand_name })) : []
  const getItemsOptions = () => itemsList.length > 0 ? itemsList?.map(item => ({ label: item.item_name, value: item.item_name, ...item })) : []

  const formatDate = (dateString) => {
    if (!dateString) return ''
    const d = new Date(dateString)
    if (Number.isNaN(d.getTime())) return ''
    return d.toISOString().split('T')[0]
  }

  const duplicateRow = (originalIndex) => {
    const newItems = [...itemsList]
    const original = newItems[originalIndex]
    const copy = { ...original }
    delete copy.id
    newItems.splice(originalIndex + 1, 0, copy)
    setItemsList(newItems)
  }

  const removeRow = (index) => {
    const newItems = [...itemsList]
    
    // newItems contains id need to trigger API 
    // else need to remove from the list
    if(newItems[index].id){
      // need confirmation before removing
      if(window.confirm('Are you sure you want to remove this item?')){  
        axios.delete(`${base_url}api/finance/itemMeta/${newItems[index].id}`).then(res => {
          toast.success('Item removed successfully')
          newItems.splice(index, 1)
          setItemsList(newItems)
        }).catch(err => {
          toast.error('Failed to remove item')
        })
      }
    }
    else{
      newItems.splice(index, 1)
      setItemsList(newItems)
    }
  }

  const validateMandatoryFields = (list) => {
    const errors = []
    list.forEach((item, idx) => {

      const missing = []
      if (!item.name) missing.push('name')
      if (!item.code) missing.push('code')
      if (!item.product_name) missing.push('product_name')
      if (!item.brand_name) missing.push('brand_name')
      if (!item.mop || `${item.mop}`.trim() === '') missing.push('dp_mop')
      // if (item.on_invoice_disc === undefined || item.on_invoice_disc === null || `${item.on_invoice_disc}`.trim() === '') missing.push('on_invoice_disc')
      // if (item.on_invoice_spike === undefined || item.on_invoice_spike === null || `${item.on_invoice_spike}`.trim() === '') missing.push('on_invoice_spike')
      if (!item.from_date || `${item.from_date}`.trim() === '') missing.push('from_date')
      if (missing.length) errors.push({ idx, missing })
    })
    return errors
  }

  const validateNoOverlap = (list) => {
    // group by code
  
    const codeToRanges = {}
    list.forEach((item, idx) => {
      const code = item.code
      if (!code) return
      const start = item.from_date ? new Date(item.from_date) : null
      const end = item.to_date ? new Date(item.to_date) : null
      if (!start || Number.isNaN(start.getTime())) return
      if (end && Number.isNaN(end.getTime())) return
      const range = { idx, start, end }
      codeToRanges[code] = codeToRanges[code] || []
      codeToRanges[code].push(range)
    })
    const overlapIdxs = new Set()
    Object.values(codeToRanges).forEach((ranges) => {
      // sort by start date
      ranges.sort((a, b) => a.start - b.start)
      for (let i = 0; i < ranges.length; i++) {
        for (let j = i + 1; j < ranges.length; j++) {
          const r1 = ranges[i]
          const r2 = ranges[j]
          const r1End = r1.end // may be null => open-ended
          // overlap if r2.start <= r1.end OR if r1 is open-ended
          if (!r1End || r2.start <= r1End) {
            overlapIdxs.add(r1.idx)
            overlapIdxs.add(r2.idx)
            //console.log("codeToRanges", codeToRanges)
          } else {
            // because sorted by start, if no overlap here, later ones won't overlap with r1
            break
          }
        }
      }
    })
    return Array.from(overlapIdxs)
  }

  useEffect(() => {
    if (overlapErrorIdxs && overlapErrorIdxs.length > 0) {
      const firstIdx = overlapErrorIdxs[0]
      const rowEl = rowRefs.current[firstIdx]
      if (rowEl && typeof rowEl.scrollIntoView === 'function') {
        rowEl.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }
  }, [overlapErrorIdxs])

  const onReportSubmit = async () => {
    // filter items with item name 
    let itemsToSubmit = []
    if(!itemName || itemName.trim() === '') {
      itemsToSubmit = itemsList
    }else{
      itemsToSubmit = itemsList.filter(item => item.name.toLowerCase().includes(itemName.toLowerCase()))
      if (itemsToSubmit.length === 0) {
        return toast.error('No items found with the given item name')
      }
    }
    // prepare list with required fields present
    // const itemsToSubmit = itemsList.filter(item => (item.mop && `${item.mop}`.trim() !== ''))
    // if (itemsToSubmit.length === 0) {
    //   return toast.error('Please enter required fields for at least one item')
    // }

    // validate mandatory fields
    
    const missingErrors = validateMandatoryFields(itemsToSubmit)
    if (missingErrors.length) {
      toast.error('Please fill all mandatory fields (from_date, dp_mop, disc, spike)')
      return
    }

    // validate overlap by code
    // validate overlap by code against the entire grid
    
    const overlapIdxs = validateNoOverlap(itemsToSubmit)
    console.log("overlapIdxs", overlapIdxs)
    if (overlapIdxs.length) {
      setOverlapErrorIdxs(overlapIdxs)
      toast.error('Date ranges overlap for the same code. Please fix highlighted rows.')
      return
    }
    setOverlapErrorIdxs([])

    let success_count = 0
    let errorItems = []
    setFinanceReportFormData(prev => ({ ...prev, submitBtnLoader: true }))

    try {
      let payloads = []
      for (const item of itemsToSubmit) {
        const payload = {
          id: item.id,
          product_name: item.product_name,
          brand_name: item.brand_name,
          name: item.name,
          code: item.code,
          from_date: item.from_date,
          to_date: item.to_date || null,
          dp_mop: item.mop,
          on_invoice_disc: item.on_invoice_disc || 0,
          on_invoice_spike: item.on_invoice_spike || 0
        }
        payloads.push(payload)
      }
      let { data } = await axios.post(`${base_url}api/finance/itemMeta/upsert-bulk`, payloads)
      //console.log(1)
      console.log("data", data)
      if(data?.status){
        toast.success(`Success ${payloads?.length} items updated`)
        // refresh grid
        const brandNames = Array.isArray(selectedBrand) && selectedBrand.length > 0
          ? selectedBrand.map(b => b.value).join(',')
          : (selectedBrand?.value || '')
        const productNames = Array.isArray(selectedProduct) && selectedProduct.length > 0
          ? selectedProduct.map(p => p.value).join(',')
          : (selectedProduct?.value || '')
        let { data } = await axios(`${base_url}api/finance/itemMetaNames?brand_name=${brandNames}&product_name=${productNames}`)
        const itemsWithDefaultDate = data?.rows.map(item => ({
          ...item,
          from_date: formatDate(item.from_date),
          to_date: formatDate(item.to_date),
          mop: item.mop ?? item.dp_mop // prefill editable value with current dp_mop

        }))
        setItemsList(itemsWithDefaultDate)
        setItemName(itemName)
      }
      else{
        toast.error(`Some items failed to update please check the data`)
      }
    } catch (e) {
      toast.error(e?.response?.data?.message || 'Error submitting data')
    } finally {
      setFinanceReportFormData({ submitBtnLoader: false })
    }
  }

  const onFormDataChange = (e) => {
    setFinanceReportFormData((prev => ({ ...prev, [e.target.name]: e.target.value })))
  }

  function convertToCSV(data) {
    if (!data || data.length === 0) return '';

    const keys = Object.keys(data[0]);
    const csvRows = [
      keys.join(','), // header row
      ...data.map((row) => keys.map(k => `"${(row[k] ?? '').toString().replace(/"/g, '""')}"`).join(','))
    ];

    return csvRows.join('\n');
  }

  function downloadCSV() {
    const csv = convertToCSV(itemsList);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    // Handle multiple brand names for filename
    const brandNames = selectedBrand?.length > 0 
      ? selectedBrand.map(brand => brand.label).join('_')
      : 'finance_report';
    link.setAttribute('download', `${brandNames}_finance_report_mop_dp.csv`);
    link.click();

    URL.revokeObjectURL(url);
  }
const handleResyncSubmit = async () => {

  if (!resyncData.month) {
    toast.error("Please select Month");
    return;
  }

  try {

    await axios.post(
      `${base_url}api/finance/resync`,
      resyncData
    );

    toast.success(
      "Resync is Started. It will take approximately 3 hours to complete. Once completed report will be generated automatically."
    );

    setShowResyncModal(false);

  } catch (err) {
    toast.error(
      err?.response?.data?.message ||
      "Failed to initiate resync"
    );
  }
};
  return (
    <>
      <div className='finance-container'>
        <div className='d-flex title-calendar-container align-items-center justify-content-around'>
          <h3 style={{ paddingTop: '10px', color: 'white', fontSize: '20px', fontWeight: 'bold' }}>Finance Reports</h3>
          <div className="d-flex gap-2">
    <button
      className="btn btn-primary"
      onClick={() => setShowResyncModal(true)}
    >
      Resync
    </button>

    <button
      className="btn btn-success"
      disabled={itemsList.length === 0}
      onClick={downloadCSV}
    >
      Export CSV
    </button>
      </div>

        </div>
        <div className='formdata'>
          <div className='row'>
            <div className={`col-md-4`}>
              <label>Product Name</label>
              <MultiSelect
                options={getProductOptions()}
                value={selectedProduct}
                onChange={onProductSelection}
                hasSelectAll={true}
                shouldToggleOnHover={false}
                overrideStrings={{
                  selectSomeItems: "Select products...",
                  allItemsAreSelected: "All products selected",
                  selectAll: "Select All",
                  search: "Search products..."
                }}
              />

            </div>
            <div className='col-md-4'>
              <label>Brand Name</label>
              <MultiSelect
                options={getBrandOptions()}
                value={selectedBrand}
                onChange={onBrandSelection}
                hasSelectAll={true}
                isLoading={brandList.loader}
                shouldToggleOnHover={false}
                overrideStrings={{
                  selectSomeItems: "Select brands...",
                  allItemsAreSelected: "All brands selected",
                  selectAll: "Select All",
                  search: "Search brands..."
                }}
              />

            </div>
            <div className='col-md-4'>
              <label>Item Name</label>
              <input
                type="text"
                placeholder='Item Name / Model name'
                name="itemName"
                value={itemName}
                className='form-control'
                onChange={(e) => setItemName(e.target.value)}
              />

            </div>

          </div>
          <div className='row mt-2'>
            {/* <div className='col-md-4'>
              <input type="text" placeholder='MOP' name="mop" value={financeReportFormData?.mop || ""} className='form-control' onChange={onFormDataChange} disabled={financeReportFormData?.submitBtnLoader} />
            </div> */}
            <div className='col-md-4 mt-2 mt-md-0'>
              {/* <button className={`btn btn-danger w-100 ${financeReportFormData?.submitBtnLoader ? "disabledBtn" : ""}`} onClick={onReportSubmit} disabled={financeReportFormData?.submitBtnLoader}>{financeReportFormData?.submitBtnLoader ? <Spinner animation="border" size="sm" /> : "Submit"}</button> */}

            </div>
            {/* <div className='col-md-4 mt-2 mt-md-0'>
            <input type="text"  className='form-control' value={financeReportFormData?.sale_disc||""} name="sale_disc" placeholder='Sell Out Discount Value' onChange={onFormDataChange} disabled={financeReportFormData?.submitBtnLoader}  />
        </div> */}
          </div>
          <div className='row mt-2'>
            {/* <div className='col-md-4 '>
            <input type="text" className='form-control' value={financeReportFormData?.sale_disc_target||""}  name="sale_disc_target" placeholder='Target Discount' onChange={onFormDataChange} disabled={financeReportFormData?.submitBtnLoader}  />
        </div>
        <div className='col-md-4 mt-2  mt-md-0'>
            <input type="text" className='form-control'  value={financeReportFormData?.spike||""} name="spike" placeholder='Spike' onChange={onFormDataChange} disabled={financeReportFormData?.submitBtnLoader} />
        </div> */}
            <div className='col-md-4 d-flex align-items-center justify-content-end mt-2  mt-md-0'>
              {/* <button className={`btn btn-danger w-100 ${financeReportFormData?.submitBtnLoader?"disabledBtn":""}` } onClick={onReportSubmit} disabled={financeReportFormData?.submitBtnLoader}>{financeReportFormData?.submitBtnLoader?<Spinner animation="border" size="sm" />:"Submit"}</button> */}
            </div>
          </div>

          <div className='row mt-2'>
            {itemsList.length > 0 && (
              <div className='col-md-12 d-flex justify-content-end mb-3'>
                <button
                  className={`btn btn-success ${financeReportFormData?.submitBtnLoader ? "disabledBtn" : ""}`}
                  onClick={onReportSubmit}
                  disabled={financeReportFormData?.submitBtnLoader}
                  style={{ minWidth: '120px' }}
                >
                  {financeReportFormData?.submitBtnLoader ? <Spinner animation="border" size="sm" /> : "Save"}
                </button>
              </div>
            )}
          </div>

          <div className='row col-md-12'>
            {itemsList.length > 0 && (
              <div className="table-responsive mt-2">
                <table className="table table-sm table-striped align-middle">
                  <thead>
                    <tr>
                      <th>Code</th>
                      <th>Name</th>
                      <th>Product</th>
                      <th>Brand</th>
                      <th>From Date</th>
                      <th>To Date</th>
                      <th>DP/MOP</th>
                      <th>Inv. Disc (%)</th>
                      <th>Inv. Spike</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {itemsList
                      .filter(item =>
                        item?.name?.toLowerCase().includes(itemName.toLowerCase())
                      )
                      .map((filteredItem) => {
                        // Find the original index in itemsList by reference
                        const originalIndex = itemsList.indexOf(filteredItem);
                        return (
                          <tr
                            key={originalIndex}
                            ref={(el) => { rowRefs.current[originalIndex] = el }}
                            className={overlapErrorIdxs.includes(originalIndex) ? 'overlap-error-row' : ''}
                          >
                            <td>{filteredItem.code}</td>
                            <td>{filteredItem.name}</td>
                            <td>{filteredItem.product_name}</td>
                            <td>{filteredItem.brand_name}</td>
                            <td>
                              <input
                                type="date"
                                className="form-control form-control-sm"
                                value={filteredItem.from_date || ''}
                                onChange={(e) => {
                                  const newItemsList = [...itemsList]
                                  newItemsList[originalIndex] = {
                                    ...newItemsList[originalIndex],
                                    from_date: e.target.value
                                  }
                                  setItemsList(newItemsList)
                                  setOverlapErrorIdxs(prev => prev.filter(i => i !== originalIndex))
                                }}
                              />
                            </td>
                            <td>
                              <input
                                type="date"
                                className="form-control form-control-sm"
                                value={filteredItem.to_date || ''}
                                onChange={(e) => {
                                  const newItemsList = [...itemsList]
                                  newItemsList[originalIndex] = {
                                    ...newItemsList[originalIndex],
                                    to_date: e.target.value
                                  }
                                  setItemsList(newItemsList)
                                  setOverlapErrorIdxs(prev => prev.filter(i => i !== originalIndex))
                                }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={filteredItem.mop || ''}
                                onChange={(e) => {
                                  const value = e.target.value.replace(/[^0-9]/g, '')
                                  const newItemsList = [...itemsList]
                                  newItemsList[originalIndex] = {
                                    ...newItemsList[originalIndex],
                                    mop: value
                                  }
                                  setItemsList(newItemsList)
                                }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={filteredItem.on_invoice_disc || ''}
                                onChange={(e) => {
                                  const value = e.target.value.replace(/[^0-9.]/g, '')
                                  const newItemsList = [...itemsList]
                                  newItemsList[originalIndex] = {
                                    ...newItemsList[originalIndex],
                                    on_invoice_disc: value
                                  }
                                  setItemsList(newItemsList)
                                }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={filteredItem.on_invoice_spike || ''}
                                onChange={(e) => {
                                  const value = e.target.value.replace(/[^0-9]/g, '')
                                  const newItemsList = [...itemsList]
                                  newItemsList[originalIndex] = {
                                    ...newItemsList[originalIndex],
                                    on_invoice_spike: value
                                  }
                                  setItemsList(newItemsList)
                                }}
                              />
                            </td>
                            <td>
                              <div className="d-flex gap-2">
                                <button className="btn btn-sm btn-outline-primary" onClick={() => duplicateRow(originalIndex)}>
                                <svg width="28px" height="28px" viewBox="0 0 1024 1024" class="icon"  version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M589.3 260.9v30H371.4v-30H268.9v513h117.2v-304l109.7-99.1h202.1V260.9z" fill="#E1F0FF" /><path d="M516.1 371.1l-122.9 99.8v346.8h370.4V371.1z" fill="#E1F0FF" /><path d="M752.7 370.8h21.8v435.8h-21.8z" fill="#446EB1" /><path d="M495.8 370.8h277.3v21.8H495.8z" fill="#446EB1" /><path d="M495.8 370.8h21.8v124.3h-21.8z" fill="#446EB1" /><path d="M397.7 488.7l-15.4-15.4 113.5-102.5 15.4 15.4z" fill="#446EB1" /><path d="M382.3 473.3h135.3v21.8H382.3z" fill="#446EB1" /><path d="M382.3 479.7h21.8v348.6h-21.8zM404.1 806.6h370.4v21.8H404.1z" fill="#446EB1" /><path d="M447.7 545.1h261.5v21.8H447.7zM447.7 610.5h261.5v21.8H447.7zM447.7 675.8h261.5v21.8H447.7z" fill="#6D9EE8" /><path d="M251.6 763h130.7v21.8H251.6z" fill="#446EB1" /><path d="M251.6 240.1h21.8v544.7h-21.8zM687.3 240.1h21.8v130.7h-21.8zM273.4 240.1h108.9v21.8H273.4z" fill="#446EB1" /><path d="M578.4 240.1h130.7v21.8H578.4zM360.5 196.5h21.8v108.9h-21.8zM382.3 283.7h196.1v21.8H382.3zM534.8 196.5h65.4v21.8h-65.4z" fill="#446EB1" /><path d="M360.5 196.5h65.4v21.8h-65.4zM404.1 174.7h152.5v21.8H404.1zM578.4 196.5h21.8v108.9h-21.8z" fill="#446EB1" /></svg>
                                </button>
                                 <button className="btn btn-sm btn-outline-danger" onClick={() => removeRow(originalIndex)} aria-label="Remove row" title="Remove row">
                                   <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 16 16" fill="currentColor">
                                     <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                                     <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2h4.118a1 1 0 0 1 .948-.684h2.868a1 1 0 0 1 .948.684H15v1h-.5zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118z"/>
                                   </svg>
                                 </button> 
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          <div className='row mt-3'>
            {itemsList.length > 0 && (
              <div className='col-md-12 d-flex justify-content-end'>
                <button
                  className={`btn btn-danger ${financeReportFormData?.submitBtnLoader ? "disabledBtn" : ""}`}
                  onClick={onReportSubmit}
                  disabled={financeReportFormData?.submitBtnLoader}
                  style={{ minWidth: '120px' }}
                >
                  {financeReportFormData?.submitBtnLoader ? <Spinner animation="border" size="sm" /> : "Save"}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

    {
showResyncModal && (
<div className="modal d-block">
  <div className="modal-dialog">
    <div className="modal-content">

      <div className="modal-header">
        <h5 className="modal-title">
          Resync Report
        </h5>

        <button
          className="btn-close"
          onClick={() => setShowResyncModal(false)}
        />
      </div>

      <div className="modal-body">

        <div className="mb-3">
          <label>Month</label>

          <select
            className="form-control"
            value={resyncData.month}
            onChange={(e)=>
              setResyncData({
                ...resyncData,
                month:e.target.value
              })
            }
          >
            <option value="">Select Month</option>

            <option value={currentDate.getMonth()+1}>
              {currentDate.toLocaleString('default',{month:'long'})}
            </option>

            <option value={currentDate.getMonth()}>
              {
                new Date(
                  currentDate.getFullYear(),
                  currentDate.getMonth()-1
                ).toLocaleString('default',{month:'long'})
              }
            </option>

          </select>
        </div>

        <div className="mb-3">
          <label>Year</label>

          <select
            className="form-control"
            value={resyncData.year}
          >
            <option value={currentDate.getFullYear()}>
              {currentDate.getFullYear()}
            </option>
          </select>
        </div>

      </div>

      <div className="modal-footer">

        <button
          className="btn btn-secondary"
          onClick={() => setShowResyncModal(false)}
        >
          Cancel
        </button>

        <button
          className="btn btn-primary"
          onClick={handleResyncSubmit}
        >
          Submit
        </button>

      </div>

    </div>
  </div>
</div>
)
}


    </>

  )
}

export default FinanceReports
